var exports = {
  "W$": "MenuItem.module__subtext___QWF2UT",
  "z": "MenuItem.module__sliderItem___QWF2UT",
  "r9": "MenuItem.module__disabled___QWF2UT",
  "Ry": "MenuItem.module__sliderHeader___QWF2UT",
  "KF": "MenuItem.module__sliderLabel___QWF2UT",
  "rv": "MenuItem.module__sliderValue___QWF2UT",
  "xJ": "MenuItem.module__sliderContainer___QWF2UT",
};

module.exports = exports;
